import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiServer, FiShield, FiFileText, FiFacebook, FiStar, FiMonitor, FiMap, FiLayout, FiSearch, FiTarget } = FiIcons;

const services = [
  { icon: FiMail, title: 'Marketing Automation', desc: 'Marketing to your list is the cheapest and most effective strategy. We will set up and deploy your email campaign to nurture leads automatically.' },
  { icon: FiServer, title: 'Premium Hosting', desc: "Speed is a ranking factor in Google. The faster your site, the more conversions you'll see. We host your site on a top-rated industry server." },
  { icon: FiShield, title: 'Website Maintenance', desc: 'Protect your asset with monthly WordPress updates, plugin updates, and security monitoring — keeping your site safe, secure, and malware-free.' },
  { icon: FiFileText, title: 'Content Marketing', desc: 'Regular blog posts and social sharing show your business is alive on all fronts. We create content, blog posts, images, and share them for you.' },
  { icon: FiFacebook, title: 'Facebook Marketing', desc: 'Building your brand is key to growth. With Facebook Ads, we put you in front of your ideal buyer where they spend their time every day.' },
  { icon: FiStar, title: 'Reputation Management', desc: 'Reviews matter. We put a review management process in place to capture happy clients and control unhappy reviews before they go public.' },
  { icon: FiTarget, title: 'Google Ads', desc: 'With 100+ cleaning service campaigns under our belt, we have a proven lead generation system with Google Ads and Bing Ads. Get results now.' },
  { icon: FiMonitor, title: 'Custom Web Design', desc: 'We build modern, SEO-optimized, graphically designed websites unique to your brand — easily editable on both the front and backend.' },
  { icon: FiMap, title: 'Local Maps SEO', desc: 'Your local MAP listing is now more important than your website. We optimize and rank your Google Maps listing to the top 3 positions.' },
  { icon: FiLayout, title: 'WordPress Themes', desc: 'Beautifully designed, high-converting custom WordPress themes — quickly add your branding, images, and content and go live fast.' },
  { icon: FiSearch, title: 'Search Engine Optimization', desc: 'Organic traffic is still key. We optimize your website to build authority and get found on page 1 of Google using On-Page and Off-Page SEO.' },
  { icon: FiTarget, title: 'Bing Ads', desc: "Bing represents 15% of all search traffic with loyal users ready to buy at a much cheaper advertising price. Don't leave money on the table." },
];

const Services = () => {
  return (
    <section id="services" className="py-24 md:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-20">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-[#8cc63f] font-semibold text-sm uppercase tracking-widest"
          >
            What We Do
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-5xl font-bold text-[#4b4b4b] mt-3 mb-5 tracking-tight"
          >
            Cleaning Service Marketing Services
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-gray-500 max-w-2xl mx-auto text-lg"
          >
            We have different cleaning business marketing packages available based on your budget.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (idx % 3) * 0.1 }}
              className="group p-8 rounded-2xl bg-white border border-gray-100 hover:border-[#8cc63f]/40 hover:shadow-xl hover:shadow-[#8cc63f]/10 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-[#8cc63f]/10 flex items-center justify-center text-[#8cc63f] mb-6 group-hover:bg-[#8cc63f] group-hover:text-white transition-all duration-300">
                <service.icon className="text-xl" />
              </div>
              <h3 className="text-lg font-bold text-[#4b4b4b] mb-3">{service.title}</h3>
              <p className="text-gray-500 leading-relaxed text-sm">{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;